import { TravelerRoomUI, TravelerItemUI } from '@pax/entities/pax-ui';
import { TravelerInfoType, TravelerTypes } from '@pax/entities/traveler-info';
import { ordinal } from '@pax/mappers/ordinal.mapper';
import { Room } from '@shared/base-search-bar/entities/room.entities';
import { TravelerPaxResponse, TravelerPaxIdentificator } from '@pax/entities/traveler-pax';
import { getDefaultDataGuestUI } from '@pax/mappers/default-pax.mapper';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';

export function guestListUI(guestPerRoom: Room[], type: SearchBy): TravelerRoomUI[] {
  const rooms = guestPerRoom
    .map((room: Room, roomIndex: number) => {
      const { [TravelerTypes.ADULTS]: adults, [TravelerTypes.CHILDREN]: children } = room;
      const adultsCollection = [].constructor(adults).fill({
        TravelerInfoType: getTravelerInfoType(type),
        TravelerType: TravelerTypes.ADULTS
      }).map((adult, index) => ({
        ...adult,
        OrdinalKey: ordinal(index + 1),
        OrdinalNumber: index + 1,
        IndexTypeNumber: index,
      }));
      const childrenCollection = [].constructor(children).fill({
        TravelerInfoType: getTravelerInfoType(type),
        TravelerType: TravelerTypes.CHILDREN
      }).map((child, index) => ({
        ...child,
        OrdinalKey: ordinal(index + 1),
        OrdinalNumber: index + 1,
        IndexTypeNumber: index,
      }));
      return {
        id: roomIndex,
        roomNumber: roomIndex + 1,
        roomGuests: adultsCollection.concat(childrenCollection).map((traveler, guestIndex) => ({
          ...traveler,
          id: getGuestId(guestIndex, roomIndex, guestPerRoom)
        }))
      };
    });
  return rooms;
}

export function setRoomGuestsByDocument(roomItem: TravelerRoomUI, guestId: number,
  identificator: TravelerPaxIdentificator): TravelerItemUI[] {
  if (roomItem) {
    const defaultSaveData = getDefaultDataGuestUI(roomItem, identificator._id, identificator.documentId, false, guestId, true);
    return [
      ...roomItem.roomGuests.slice(0, guestId),
      { ...roomItem.roomGuests[guestId], defaultData: defaultSaveData },
      ...roomItem.roomGuests.slice(guestId + 1)
    ];
  } else return [];
}

export function setRoomGuests(
  roomItem: TravelerRoomUI,
  guestId: number,
  payload: TravelerPaxResponse,
  identificator: TravelerPaxIdentificator = null,
  isConfigDefault: boolean = false
): TravelerItemUI[] {
  if (roomItem) {
    if (identificator) {
      const defaultSaveData = getDefaultDataGuestUI(roomItem, identificator._id, identificator.documentId,
        isConfigDefault, guestId);
      return [
        ...roomItem.roomGuests.slice(0, guestId),
        { ...roomItem.roomGuests[guestId], defaultData: defaultSaveData },
        ...roomItem.roomGuests.slice(guestId + 1)
      ];
    } else if (payload) {
      return [
        ...roomItem.roomGuests.slice(0, guestId),
        { ...roomItem.roomGuests[guestId], defaultData: { ...payload, isConfigDefault } },
        ...roomItem.roomGuests.slice(guestId + 1)
      ];
    } else {
      return [
        ...roomItem.roomGuests.slice(0, guestId),
        { ...roomItem.roomGuests[guestId], defaultData: null },
        ...roomItem.roomGuests.slice(guestId + 1)
      ];
    }
  } else return [];
}

export function guestIdentificatorUI(id: number, guestId: number): string {
  return `ROOM_${id}_${TravelerInfoType.GUEST}_${guestId}`;
}

function getGuestId(index: number, room: number, rooms: Room[]): number {
  let item = 0;
  const filterRooms = rooms.filter(itemRoom => itemRoom.id < room);
  const previewChildrenQuantity = sumGuestBy(TravelerTypes.CHILDREN, filterRooms);
  const previewAdultsQuantity = sumGuestBy(TravelerTypes.ADULTS, filterRooms);
  const previewQuantity = previewAdultsQuantity + previewChildrenQuantity;
  item += index + previewQuantity;
  return item;
}

function sumGuestBy(key: string, rooms: Room[]): number {
  return rooms.reduce((accumulator, currentValue) => accumulator + (currentValue[key] || 0), 0);
}

function getTravelerInfoType(type: SearchBy): TravelerInfoType {
  switch (type) {
    case SearchBy.PACKAGES:
      return TravelerInfoType.PACKAGE_TRAVELER;
    default:
      return TravelerInfoType.GUEST;
  }
}
